import { primaryTargetGroupLabels } from '../dataHelpers/targetgroupCategories'

/**
 * Leesbare naam van de doelgroep waarop een ISS-cel inzoomt.
 *
 * Een segmentcel telt alleen de respondenten die via hun onderzoek aan die
 * doelgroep hangen. Hij staat dus naast een ongesegmenteerde cel met dezelfde
 * dimensie en hetzelfde onderwerp, maar met andere aantallen — zonder deze
 * naam erbij lezen die twee als één rij met tegenstrijdige cijfers.
 *
 * Een sleutel die de taxonomie (nog) niet kent, komt onvertaald terug. Leeg
 * teruggeven zou de cel als ongesegmenteerd laten lezen, en dat is een
 * zwaardere fout dan een lelijk label.
 *
 * Eén plek, omdat er drie afnemers zijn (agenda, celtabel, nachtelijke
 * controle) die anders elk hun eigen terugval krijgen.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {string|null|undefined} segment - Doelgroepsleutel uit de taxonomie
 * @returns {string} Leesbare naam, of '' als de cel ongesegmenteerd is
 */
export const segmentLabel = (segment) => (
    typeof segment === 'string' && segment
        ? (primaryTargetGroupLabels[segment] || segment)
        : ''
)

export default segmentLabel
